import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { COLORS } from "../../theme";
import { useTheme } from "@mui/material/styles";
import {imgButtonSkewedWhite} from "../../assets/images/button_skewed_white";
import {imgButtonSkewedBlack} from "../../assets/images/button_skewed_black";
import {imgButtonSkewedBrown} from "../../assets/images/button_skewed_brown";
import {imgButtonSkewedPurple} from "../../assets/images/button_skewed_purple";
import {imgButtonSkewedGreen} from "../../assets/images/button_skewed_green";


const Timeline = (props) => {
  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"), {
    noSsr: true,
  });

  const images = [
    imgButtonSkewedWhite,
    imgButtonSkewedBlack,
    imgButtonSkewedBrown,
    imgButtonSkewedPurple,
    imgButtonSkewedGreen,
  ];

  const answerSelected = (value) => {
    if (props.answerSelected) props.answerSelected(value);
  };

  return (
    <Box
      sx={{
        width: { md: "70%", xs: "90%" },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {props.quiz &&
        props.quiz.options.map((answer, index) => {
          return (
            <Box
              sx={{
                height: { xs: 60, md: 150 },
                width: { xs: 60, md: 150 },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              onClick={() => answerSelected(answer)}
            >
               <Box
                style={{
                  backgroundImage: `url('${images[index]}'`,
                  backgroundPosition: "50% 50%",
                  width: isMobile?"60px": "150px",
                  height: isMobile?"60px": "150px" ,
                  backgroundRepeat: "no-repeat",
                  backgroundSize:"60px 60px",
                  borderRadius: "10px",
                  position: "absolute",
                }}
              />
              <span
                style={{
                  color: index%2===0?COLORS.black:COLORS.white,
                  zIndex: 10,
                  fontFamily: "'ATGRubrik'",
                  fontSize: 15
                }}
              >
                {answer}
              </span>
            </Box>
          );
        })}
    </Box>
  );
};

export default Timeline;
